// TTS Settings and Configuration Constants

export const TTS_TIMEOUTS = {
  // Default timeout for TTS API requests (in milliseconds)
  DEFAULT: 30000, // 30 seconds
  
  // Timeout for express TTS requests (should be shorter)
  EXPRESS: 15000, // 15 seconds
  
  // Timeout for standard/batch TTS requests (can be longer)
  STANDARD: 60000, // 60 seconds
  
  // Timeout for status check after timeout
  STATUS_CHECK: 10000, // 10 seconds
}

export const TTS_RETRY_SETTINGS = {
  // Maximum number of retries for failed requests
  MAX_RETRIES: 3,
  
  // Initial retry delay in milliseconds
  INITIAL_DELAY: 1000,
  
  // Maximum retry delay in milliseconds
  MAX_DELAY: 30000,
  
  // Whether to check job status after timeout
  CHECK_STATUS_ON_TIMEOUT: true,
}

export const TTS_LIMITS = {
  // Maximum characters for what the UI now calls Streaming mode. The
  // enum value 'express' is kept on the API for backward compatibility
  // (external integrators still send inference_mode='express') — the
  // 2026-09 naming pass renamed the user-facing label to "Streaming"
  // and unified it across Creole Regional (VITS) and Creole Studio Pro
  // (Gemini 3.1).
  MAX_EXPRESS_CHARS: 1000,
  
  // Maximum characters for standard mode
  MAX_STANDARD_CHARS: 5000,
  
  // Maximum characters for extended plans
  MAX_EXTENDED_CHARS: 10000,
}

export const getTimeoutForMode = (inferenceMode) => {
  switch (inferenceMode) {
    case 'express':
      return TTS_TIMEOUTS.EXPRESS
    case 'standard':
      return TTS_TIMEOUTS.STANDARD
    default:
      return TTS_TIMEOUTS.DEFAULT
  }
}